import axios from "axios";
import { toast } from "react-toastify";
import { API_URL, FOLDERPATH } from "../Constants/config";

import {
  FEEDBACK_LOADING,
  FEEDBACK_SUCCESS,
  FEEDBACK_FAILED,
} from "../Constants/feedbackConstants";

import {
  FEEDBACK_SAVE_LOADING,
  FEEDBACK_SAVE_SUCCESS,
  FEEDBACK_SAVE_FAILED,
} from "../Constants/feedbackConstants";

import { handleApiError } from "../Helper/actionHelper";

export const saveFeedback = (record) => async (dispatch) => {
  try {

    let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  

    dispatch({ type: FEEDBACK_SAVE_LOADING });

    console.log(typeof record);
    
    const requestData = {
      token:
      userLocalData.id,
      rating_new: record[0],
      feedback_comment: record[1],
      feedback_comment_text: record[2]
      
    };

    //console.log(requestData);
    
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(FOLDERPATH + 
      "/CandidateApi/feedback",
      requestData,
      {
        headers: headers,
      } 
    );

    dispatch({
      type: FEEDBACK_SAVE_SUCCESS,
      payload: data,
    });

    handleApiError(data);

  }catch (error) {
      dispatch({
        type: FEEDBACK_SAVE_FAILED,
        payload:
          error.response && error.response.data.message
            ? error.response
            : error.response,
      });
      handleApiError(error);
    }
  };

    // const msg = "Saved Successfully";

    // toast.success(msg, {
    //   position: "top-right",
    //   autoClose: 5000,
    //   hideProgressBar: false,
    //   closeOnClick: true,
    //   pauseOnHover: true,
    //   draggable: true,
    //   progress: undefined,
    // });


export const deleteSaveFeedback = () => (dispatch) => {
  dispatch({
    type: FEEDBACK_SAVE_SUCCESS,
    payload: [],
  });
};



